import 'react-responsive-carousel/lib/styles/carousel.min.css'

import { Box, Image } from '@chakra-ui/react'
import { Carousel } from 'react-responsive-carousel'

import { getFileUrl, isMobile } from '../CourseDetail/Practice/Util'
import {noImageFoundText} from "src/component/constants"

const ImageSlider = ({
  slides,
  px,
  sx,
  borderRadius,
  centerMode = false,
  onChange,
  autoPlay = false,
  onClick,
  interval = 3000,
  width = '100%',
}) => {
  const getImageUrl = item => {
    return item?.image
      ? item.image
      : getFileUrl(isMobile ? item?.mobileImageUrl : item?.imageUrl)
  }
  return (
    <Box cursor={'pointer'}>
      <Carousel
        infiniteLoop
        px={px}
        autoFocus={false}
        centerMode={centerMode}
        autoPlay={autoPlay}
        interval={interval}
        emulateTouch={true}
        dynamicHeight={true}
        onChange={onChange}
        onClickItem={onClick}
        showStatus={false}
        showThumbs={false} //To Resolve main page warnings
      >
        {slides?.map(item => {
          return (
            <Image
              sx={sx}
              key={getImageUrl(item)}
              borderRadius={borderRadius}
              src={getImageUrl(item)}
              alt={noImageFoundText}
              style={{
                width: width,
                minHeight: "250px",
                maxHeight: "300px"
              }}
            />
          )
        })}
      </Carousel>
    </Box>
  )
}
export default ImageSlider
